import { optionsObjectToArray } from "@/common/utils/optionsObjectToArray";
import { BranchHierarchyForUserAccess } from "@/features/company/types/company.type";

export const branchHierarchyForUserAccess = {
  [BranchHierarchyForUserAccess.SameOnly]: 'Apenas esta filial',
  [BranchHierarchyForUserAccess.SameAndDescendents]: 'Esta filial e descendentes',
}

export const branchHierarchyForUserAccessOptions = optionsObjectToArray(branchHierarchyForUserAccess);
